
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6glefbi06gv2c9ufheg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      if (response.ok) {
        form.reset();
      }
    } catch (error) {
      // handle error silently
    }
  };

  return (
    <footer className="bg-[#2A1A1A] py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-16 pb-12 border-b border-rose-900/40">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-store-3-line text-3xl text-rose-400"></i>
            </div>
            <span className="text-xl font-serif font-semibold text-white">Mount Zion Investment INC</span>
          </div>
          <p className="text-gray-400 text-sm max-w-md text-right">
            Premium retail store builder specializing in beauty &amp; skincare boutiques
          </p>
        </div>

        <div className="grid grid-cols-4 gap-12 mb-16">
          <div>
            <h4 className="text-white font-bold text-base mb-6">Our Stores</h4>
            <ul className="space-y-4">
              <li><a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Lip Collection</a></li>
              <li><a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Skincare</a></li>
              <li><a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Eye Makeup</a></li>
              <li><a href="#services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">New Arrivals</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-base mb-6">Company</h4>
            <ul className="space-y-4">
              <li><a href="#about" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#about" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Our Team</a></li>
              <li><a href="#about" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#about" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Press</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-base mb-6">Build With Us</h4>
            <ul className="space-y-4">
              <li><a href="#contact" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Store Concepts</a></li>
              <li><a href="#contact" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Get a Quote</a></li>
              <li><a href="#contact" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#contact" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
            </ul>
          </div>

          <div className="text-right">
            <p className="text-white font-serif text-lg mb-2">© Mount Zion Investment INC {new Date().getFullYear()}</p>
            <p className="text-gray-400 text-sm mb-6">All rights reserved</p>
            <div className="flex items-center justify-end gap-5">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-rose-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-rose-400 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-xl"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-rose-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-rose-400 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="flex items-end justify-between gap-12 pt-12 border-t border-rose-900/40">
          <div className="w-[280px] h-[180px] rounded-xl overflow-hidden shadow-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/bc7601508cb4e394e980bad12aae888a.jpg"
              alt="Store Interior"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1">
            <p className="font-serif text-gray-400 text-3xl leading-relaxed">
              Discover Your Glow.<br />
              Embrace Your Beauty.<br />
              Love Every Look.
            </p>
          </div>

          <div className="w-[460px]">
            <p className="text-gray-400 text-sm mb-5">
              Get exclusive beauty tips, new arrivals &amp; special offers
            </p>
            <form onSubmit={handleSubmit} className="flex items-center gap-3" data-readdy-form id="newsletter-subscription">
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                className="flex-1 bg-transparent border border-rose-900/50 rounded-lg px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-rose-400 transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-rose-500 text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-rose-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </footer>
  );
}